export const getPermittedMenuConfig = ({ menuConfig = [], userContext, entityContext }) => {
  const { user, role } = userContext;
  const entitlements = entityContext?.entitlements;

  if (!user || !role || !entitlements) {
    return menuConfig;
  }

  const filterConfig = config => {
    const activeEntitlements = entitlements?.entitlements?.filter(e => e.status === 'ACTIVE') || [];

    // Check if the config has permissionsApp and if the user has the required entitlements
    if (config?.permissionsApp?.length) {
      if (!entitlements?.apps?.some(entitlement => config.permissionsApp.includes(entitlement.crn))) {
        return false;
      }
    }

    // Check if the config has permissionsSKU and if the user has the required entitlements
    if (config?.permissionsSKU?.length) {
      if (!activeEntitlements.some(entitlement => config.permissionsSKU.includes(entitlement.crn))) {
        return false;
      }
    }

    // Exclude menu item if entitlements has any SKUs listed in config.hiddenForSKUs
    if (config?.hiddenForSKUs?.length) {
      if (activeEntitlements.some(entitlement => config.hiddenForSKUs.includes(entitlement.crn))) {
        return false;
      }
    }

    if (user?.isPlatformAdmin || user?.isPlatformSupport) return true;

    if (config?.platformSupportOnly) {
      return false;
    }

    if (config?.platformAdminOnly && !user?.isPlatformAdmin) {
      return false;
    }

    // Check if the config has permissions and if the user has the required role permissions
    const configPermissions = [].concat(config?.permissions).filter(permission => !!permission);
    if (configPermissions?.length) {
      if (role?.permissions?.includes?.('*')) return true;
      return configPermissions?.[config.permissionStrategy || 'some']?.(p => role?.permissions?.includes(p));
    }

    return true;
  };

  // Temporary workaround to support both menuConfig shapes until everyone has changed to the new format.
  const permitted = (menuConfig?.sidebarOptions || menuConfig)
    .map(menuItem => {
      if (!filterConfig(menuItem)) return null;

      // Leaf items have no children in source — return as-is to preserve leaf semantics
      if (!menuItem?.children) {
        return { ...menuItem };
      }

      // Filter children, always returning new objects/arrays
      const filteredChildren = menuItem.children
        .map(childItem => {
          if (!filterConfig(childItem)) return null;

          // Leaf child has no children in source — preserve leaf semantics
          if (!childItem.children) {
            return { ...childItem };
          }

          const filteredGrandchildren = childItem.children.filter(filterConfig);

          // If the only grandchild is the home page, don't show this child
          if (filteredGrandchildren.length === 1 && filteredGrandchildren[0]?.isHomePage) {
            return null;
          }

          return {
            ...childItem,
            children: filteredGrandchildren,
          };
        })
        .filter(Boolean);

      // If the only child is the home page, don't show the parent
      if (filteredChildren.length === 1 && filteredChildren[0]?.isHomePage) {
        return null;
      }

      return {
        ...menuItem,
        children: filteredChildren,
      };
    })
    .filter(Boolean);

  if (menuConfig.sidebarOptions) {
    return {
      ...menuConfig,
      sidebarOptions: permitted,
    };
  }

  return permitted;
};
